import { render, staticRenderFns } from "./resourceRecycle.vue?vue&type=template&id=13377197&scoped=true"
import script from "./resourceRecycle.vue?vue&type=script&lang=js"
export * from "./resourceRecycle.vue?vue&type=script&lang=js"
import style0 from "./resourceRecycle.vue?vue&type=style&index=0&id=13377197&scoped=true&lang=scss"
import style1 from "./resourceRecycle.vue?vue&type=style&index=1&id=13377197&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13377197",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13377197')) {
      api.createRecord('13377197', component.options)
    } else {
      api.reload('13377197', component.options)
    }
    module.hot.accept("./resourceRecycle.vue?vue&type=template&id=13377197&scoped=true", function () {
      api.rerender('13377197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customers/resourceRecycle.vue"
export default component.exports